<template>
  <section>
    <v-toolbar class="box-shadow">
      <v-text-field hide-details outlined clearable placeholder="Search" dense v-model="search"></v-text-field>
      <v-btn class="ml-3 box-shadow" color="primary" @click="create_item_dialog = !create_item_dialog">Create new</v-btn>
    </v-toolbar>

    <v-container fluid>
      <v-card>
        <v-data-table :headers="table_data.headers"
                      :items="table_data.items"
                      :search="search">
          <template v-slot:item.session_types="{ item }">
            <div v-for="type in item.session_types" :key="type.value">
              {{ `${type.name} - ${type.count}` }}
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon class="mr-2" @click="openSelectedItemDialog(item)">mdi-pencil</v-icon>
          </template>
        </v-data-table>
      </v-card>


      <v-dialog v-model="create_item_dialog" max-width="500px">
        <v-form v-if="course" class="text-center" @submit="createItem">
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="closeCreateItemDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Create Package</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text type="submit">Save</v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text v-if="course">
              <v-select label="Package Name"
                        v-model="new_item.name"
                        :items="name_options"
                        item-text="name"
                        item-value="id"
                        :error-messages="api_errors['name']"
              />

              <v-text-field label="Price" v-model="new_item.price" :error-messages="api_errors['price']">
                <span slot="append">GBP</span>
              </v-text-field>

              <v-textarea label="Package Description" outlined
                          v-model="new_item.description"
                          :error-messages="api_errors['description']"
              />

              <v-row>
                <v-col cols="12" md="6" v-for="(session_type, idx) in course.session_types" :key="idx">
                  <v-text-field
                      :label="'Count ' + session_type.name"
                      v-model="new_item.session_types[session_type.id]"
                      color="secondary"
                      type="number"
                      validate-on-blur
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="selected_item_dialog" max-width="500px">
        <v-form v-if="selected_item_dialog" @submit="updateSelectedItem">
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="closeSelectedItemDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Settings</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text type="submit">Save</v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text>
              <v-select label="Package Name"
                        v-model="selected_item.name"
                        :items="name_options"
                        item-text="name"
                        item-value="id"
                        :error-messages="api_errors['name']"
              />

              <v-text-field label="Price"
                            v-model="selected_item.price"
                            :error-messages="api_errors['price']">
                <span slot="append">GBP</span>
              </v-text-field>

              <v-textarea label="Package Description"
                          v-model="selected_item.description"
                          :error-messages="api_errors['description']"
                          outlined
              />

              <v-text-field
                  v-for="(session_type, idx) in selected_item.session_types" :key="idx"
                  v-model="selected_item.session_types[idx].count"
                  color="secondary"
                  :label="'Count ' + session_type.name"
                  type="number"
                  validate-on-blur
              />

            </v-card-text>
            <!--          <v-divider/>-->
            <!--          <v-card-actions>-->
            <!--            <v-btn color="red" block @click="deletePackage">-->
            <!--              <v-icon>mdi-delete</v-icon>-->
            <!--              Delete-->
            <!--            </v-btn>-->
            <!--          </v-card-actions>-->
          </v-card>
        </v-form>
      </v-dialog>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'Packages',
  props: {
    course: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    table_data: {
      headers: [
        { text: 'Package Name', value: 'name' },
        { text: 'Session Types', value: 'session_types' },
        // { text: 'Package Description', value: 'description' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: []
    },
    search: '',
    create_item_dialog: false,
    new_item: {
      name: '',
      session_types: {},
      description: '',
      price: '',
    },
    selected_item_dialog: false,
    selected_item: null,

    api_errors: [],

    name_options: [
      'ALL IN',
      'BUDGET',
      'LPC',
      'DOUBLE',
      'Extra1',
      'Extra2',
      'Extra3',
    ],
  }),
  watch: {
    content: function (val) {
      this.course = Object.assign({}, val)
    },
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.table_data.items = await this.axios.get(`api/packages`).then(({data}) => data.data)
    },
    closeCreateItemDialog() {
      this.create_item_dialog = false;
      this.new_item = {
        name: '',
        session_types: {},
        description: '',
        price: '',
      }
    },
    createItem(e) {
      e.preventDefault()
      this.api_errors = []
      let sessionTypes = Object.keys(this.new_item.session_types).map(item => {
        return { id: item, count: this.new_item.session_types[item]}
      })
      this.axios.post(`api/practice-areas`, {
        name: this.new_item.name,
        price: this.new_item.price,
        description: this.new_item.description,
        session_types: sessionTypes
      })
          .then(({data}) => {
            this.table_data.items.unshift(data.data)
            this.closeCreateItemDialog()
          })
          .catch(({response}) => { this.api_errors = response.data.errors })
    },
    openSelectedItemDialog(item) {
      this.selected_item = item
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
    },
    updateSelectedItem(e) {
      e.preventDefault()
      this.api_errors = []
      this.axios.put(`api/practice-areas/${this.selected_item.id}`, {
        name: this.selected_item.name,
        short_name: this.selected_item.short_name,
        weekday: this.selected_item.weekday,
      })
          .then(() => {
            this.loadData()
            this.closeSelectedItemDialog()
          })
          .catch(({response}) => { this.api_errors = response.data.errors })
    },
  }
}
</script>
